<template>
  <div>
    <cool-select
      ref="coolselect"
      v-model="selected"
      :items="items"
      :loading="loading"
      item-text="name"
      :placeholder="placeholder"
      disable-filtering-by-search
      @search="onSearch"
      size="lg"
      @input.stop.prevent="selectItem"
    >
      <!-- <template #no-data>
        
        {{
          noData
            ? "No information found by request."
            : "We need at least 2 letters to search."
        }}
      </template> -->
      <template #item="{ item }">
        <div class="item text-left">
          <!-- <img :src="item.logo" class="logo" /> -->

          <div>
            <img height="25" :src="item.image" />
            <span class="item-name ml-2 mt-1"> {{ item.name }} </span> <br />
            <!-- <span class="item-domain"> {{ item.domain }} </span> -->
          </div>
        </div>
      </template>
      <template v-if="loading" #input-end>
        <!-- You can use your own loading spinner -->
        <div
          class="spinner-border spinner-border-sm text-primary mr-2"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
        <!-- <img
        height="10"
        src="https://i.imgur.com/mTNe6tr.gif"
        class="loading-indicator"
      /> -->
      </template>
    </cool-select>
  </div>
</template>

<script>
import { CoolSelect } from "vue-cool-select";
import axios from "@/plugins/axios";
import { mapState } from 'vuex';

export default {
  name: "Cool-Select",
  props: {
    value: {
      type: Object,
      default: {},
    },
    searchWith: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    selected: null,
    items: [],
    loading: false,
    timeoutId: null,
    noData: false,
  }),
  methods: {
    clearSelect() {
      this.selected = null;
      this.items = [];
    },
    selectItem(data = null) {

      switch (this.searchWith) {
        case "barcode":
          if (data == null) this.$emit("selected", this.selected);
          else this.$emit("selected", data);
          break;
        case "batch":
          if (data == null) this.$emit("selected", this.selected);
          else this.$emit("selected", data);
          break;
        case "product_name":
          if (data == null) this.$emit("selected", this.selected);
          else this.$emit("selected", data);
          break;
      }
    },
    async onSearch(search_string) {
      switch (this.searchWith) {
        case "barcode":
          this.barCodeSearch(search_string);
          break;
        case "batch":
          this.batchSearch(search_string);
          break;
        case "product_name":
          this.nameSearch(search_string);
          break;
      }
    },
    async barCodeSearch(search) {
      const lettersLimit = 1;

      this.noData = false;
      if (search.length < lettersLimit) {
        this.items = [];
        this.loading = false;
        return;
      }
      this.loading = true;
      let self = this;

      axios
        .get("pos/shops/"+this.shop_info.id+"/product-search", { barcode: search })
        .then((res) => {
          if (res.data.data.length != 0) {
            if ([res.data.data].length == 1) {
              self.items = [res.data.data];
              self.selected = res.data.data;
              this.selectItem(res.data.data);

              // setTimeout(() => {
              //   self.$refs.coolselect.setSearchData(res.data.data);
              // }, 1000);
            } else {
              self.items = [res.data.data];
            }
          }
          if (!res.data.data) self.noData = true;
          self.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    async batchSearch(search) {
      const lettersLimit = 1;

      this.noData = false;
      if (search.length < lettersLimit) {
        this.items = [];
        this.loading = false;
        return;
      }
      this.loading = true;

      axios
        .get("pos/search/batch", { query: search })
        .then((res) => {
          this.items = res.data.data;
          if (!this.items.length) this.noData = true;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    async nameSearch(search) {
      const lettersLimit = 1;

      this.noData = false;
      if (search.length < lettersLimit) {
        this.items = [];
        this.loading = false;
        return;
      }
      this.loading = true;
      axios
        .get(`pos/shops/${this.shop_info.id}/products`, { query: search })
        .then((res) => {
          this.items = res.data.data;
          if (!this.items.length) this.noData = true;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  computed: {
    placeholder: function() {
      switch (this.searchWith) {
        case "barcode":
          return "Barcode";
          break;
        case "batch":
          return "Batch";
          break;
        case "product_name":
          return "Product Name";
          break;
      }
    },
     ...mapState('shops', ['shop_info']),
  },
  components: { CoolSelect },
};
</script>
<style>
.IZ-select__item.IZ-select__item--selected {
  color: #1976d2 !important;
  background: #cde8ff !important;
}
</style>
